var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashSolid = function SvgDashSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.714 0H2.5C1 0 0 1 0 2.5v11C0 15 1 16 2.5 16h2.214zM16 10.714V13.5c0 1.5-1 2.5-2.5 2.5H6.714v-5.286zM6.714 0H13.5C15 0 16 1 16 2.5v6.214H6.714z"
  })));
};
export { SvgDashSolid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik00LjcxNCAwSDIuNUMxIDAgMCAxIDAgMi41djExQzAgMTUgMSAxNiAyLjUgMTZoMi4yMTR6TTE2IDEwLjcxNFYxMy41YzAgMS41LTEgMi41LTIuNSAyLjVINi43MTR2LTUuMjg2ek02LjcxNCAwSDEzLjVDMTUgMCAxNiAxIDE2IDIuNXY2LjIxNEg2LjcxNHoiLz48L3N2Zz4K";